import React, { useEffect, useState } from "react";
import { ToastContainer, Slide } from "react-toastify";

const getIsDark = () => document.body.classList.contains("dark");

export const ThemedToastContainer: React.FC = () => {
    const [isDark, setIsDark] = useState<boolean>(getIsDark);

    useEffect(() => {
        const observer = new MutationObserver(() => {
            setIsDark(getIsDark());
        });
        observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
        return () => observer.disconnect();
    }, []);

    return (
        <ToastContainer
            position="top-right"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnHover
            pauseOnFocusLoss
            draggable
            theme={isDark ? "dark" : "light"}
            transition={Slide}
        />
    );
};
